import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useUser } from '@/contexts/UserContext';

interface GuestRouteProps {
  children: ReactNode;
}

/**
 * Renders auth pages (e.g. login) only for unauthenticated visitors.
 * Once a user is logged in, any attempt to reach these pages — including via the
 * browser back button — redirects to the role-based landing route (`Index`),
 * so users can never navigate back to the login screen after signing in.
 */
const GuestRoute = ({ children }: GuestRouteProps) => {
  const { currentUser, isInitialized, isLoading } = useUser();

  if (isLoading || !isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center space-y-4">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
          <p>
            {!isInitialized ? 'Initializing...' : 'Loading...'}
          </p>
        </div>
      </div>
    );
  }

  if (currentUser) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default GuestRoute;
